<template>
  <div>
    <v-row class="mx-auto" justify="center" no-gutters>
      <v-col cols="12" :md="isVideoExisted ? 6 : 12">
        <v-row no-gutters class="mx-auto" justify="center">
          <v-col cols="12">
            <critical-general :event="event" :raw-values="rawValues"
                              :nano-user="nanoUser"></critical-general>
          </v-col>
        </v-row>
        <v-row no-gutters class="mx-auto mt-2" justify="center">
          <v-col cols="12">
            <critical-context :event="event" :raw-values="rawValues"
                              :nano-user="nanoUser"></critical-context>
          </v-col>
        </v-row>
      </v-col>

    </v-row>

    <critical-statistics-filter-values v-if="Object.keys(filters).length > 0"
                                       :route-state="routeState"
                                       :additional-statistics="filters"
                                       :debug="debugMode">
    </critical-statistics-filter-values>

    <v-scroll-y-transition leave-absolute hide-on-leave>
      <v-container fluid>
        <v-row justify="center" no-gutters v-if="isVideoExisted || isRoadVideoExisted">
          <v-col :cols="videoWidth" align-self="center" justify-self="center" v-if="isVideoExisted">
            <critical-video :ref="`video_driver_${event.idCriticalEvent}`" :event="event" :user-id="userId"
                            @media-duration="driverDuration = $event"
                            @video-ended="resetSyncSlider"
                            :is-forced-video="isForcedVideo" :is-auto-play="isAutoPlay"
                            :fetch-fps="true"></critical-video>
          </v-col>
          <v-col :cols="videoRoadWidth" align-self="center" justify-self="center" v-if="isRoadVideoExisted">
            <critical-video :ref="`video_road_${event.idCriticalEvent}`" :event="event" :user-id="userId"
                            @media-duration="roadDuration = $event"
                            @video-ended="resetSyncSlider"
                            :video-type="UploadVideoTypes.ROAD"
                            :is-forced-video="isForcedVideo" :is-auto-play="isAutoPlay"
                            :fetch-fps="true"></critical-video>
          </v-col>
        </v-row>
        <critical-video-sync-slider ref="videoSyncSlider"
                                    v-if="isVideoExisted && isRoadVideoExisted"
                                    :driver-duration="driverDuration"
                                    :road-duration="roadDuration"
                                    @play-all-video="playAllVideo"
                                    @stop-all-video="stopAllVideo"
                                    @duration-changed="setVideoDurations">
        </critical-video-sync-slider>
      </v-container>
    </v-scroll-y-transition>
  </div>
</template>

<script>
import CriticalGeneral from '../criticalGeneral'
import CriticalContext from '../criticalContext'
import CriticalVideo from '../criticalVideo'
import { CriticalEvent } from '@/models/map/CriticalEvent'
import { createHelpers } from 'vuex-map-fields'
import { AUTH_MODULE, SETTINGS_MODULE } from '@/store/modules'
import { Route } from '@/models/travel/Route'
import CriticalStatisticsFilterValues from '../criticalStatisticsFilterValues'
import { UploadVideoTypes } from '@/enum'
import CriticalVideoSyncSlider from '@/components/map/criticalPopup/criticalVideoSyncSlider'

const { mapFields: settingsFields } = createHelpers({
  getterType: `${SETTINGS_MODULE}/getField`
})

const { mapFields: authFields } = createHelpers({
  getterType: `${AUTH_MODULE}/getField`
})

export default {
  name: 'criticalPopupGeneralMobile',
  components: {
    CriticalVideoSyncSlider,
    CriticalStatisticsFilterValues,
    CriticalVideo,
    CriticalContext,
    CriticalGeneral
  },
  props: {
    event: CriticalEvent,
    filters: Object,
    nanoUser: Boolean,
    rawValues: Boolean,
    isVideoExisted: Boolean,
    isRoadVideoExisted: Boolean,
    userId: Number,
    isForcedVideo: {
      type: Boolean,
      default: false
    },
    isAutoPlay: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    routeState: new Route().routeState().filter(item => item.hasOwnProperty('style')),
    roadDuration: 0,
    driverDuration: 0
  }),
  computed: {
    ...authFields(['isAdmin']),
    ...settingsFields(['videoSettings.videoWidth', 'videoSettings.videoRoadWidth']),
    debugMode () {
      return this.isAdmin && this.rawValues
    }
  },
  methods: {
    setVideoDurations (value) {
      for (const element of Object.values(this.$refs)) {
        if ('setDuration' in element) {
          element.setDuration(value)
        }
      }
    },
    playAllVideo () {
      for (const element of Object.values(this.$refs)) {
        if ('playVideo' in element) {
          element.playVideo()
        }
      }
    },
    stopAllVideo () {
      for (const element of Object.values(this.$refs)) {
        if ('stopVideo' in element) {
          element.stopVideo()
        }
      }
    },
    resetSyncSlider () {
      this.$refs['videoSyncSlider'].resetState()
    }
  },
  created () {
    this['UploadVideoTypes'] = UploadVideoTypes
  }
}
</script>

<style scoped>

</style>
